<template>
    <div> 
        <vs-table v-model="selectedRow" class="bloques mr-0 ml-0 unset-min-width left-footer-unset-radius left-header-unset-radius" style="width: 100%;">
            <template #header style="background: none">
                <div class="grid">
                    <vs-row style="justify-content: flex-end">
                        <vs-col style="display: flex; justify-content: center;" w="1">
                            <vs-button success large circle icon floating @click="activeCrear=!activeCrear">
                                <i class='fas fa-plus mini-icon mr-1' ></i> Agregar
                            </vs-button>
                            <modal-crear-codigo v-model="activeCrear" :institucion="institucion" :list-ciclos="listCiclos" :list-niveles="listNiveles" :ciclo-escolar-id="cicloEscolar" :nivel-academico-id="nivelAcademico" :programa-id="programa" @refreshTable="tablaCodigos" ></modal-crear-codigo>
                            <modal-editar-codigo v-model="activeEditar" :row-data="selectedRow" :institucion="institucion" :list-ciclos="listCiclos" :list-niveles="listNiveles" @refreshTable="tablaCodigos" ></modal-editar-codigo>
                            <modal-eliminar-codigo v-model="activeEliminar" :row-data="selectedRow" @refreshTable="tablaCodigos" ></modal-eliminar-codigo>
                            <modal-agregar-crns v-model="activeCrn" :row-data="selectedRow" @refreshTable="tablaCodigos" :institucion="institucion" :list-ciclos="listCiclos" :list-niveles="listNiveles" :row="info"></modal-agregar-crns>
                        </vs-col>
                    </vs-row>
                </div>
            </template>
            <template #thead>
                <vs-tr>
                    <vs-th style="width: 5% !important;">
                        
                    </vs-th>
                    <vs-th style="width: 10% !important;">
                        Nombre
                    </vs-th>
                    <vs-th style="width: 10% !important;">
                        Código de sesión
                    </vs-th>
                    <vs-th style="width: 20% !important;">
                        Ciclo Escolar
                    </vs-th>
                    <vs-th style="width: 20% !important;">
                        Programa
                    </vs-th>
                    <vs-th style="width: 20% !important;">
                        Nivel
                    </vs-th>
                    <vs-th>
                        Acciones
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i.id"
                    v-for="(tr, i) in tablaData"
                    :data="tr"
                    :is-selected="(selectedRow && selectedRow.id) == (tr &&tr.id)"
                >
                    <vs-td>
                        <i class="fas fa-caret-down"></i>
                    </vs-td>
                    <vs-td>
                        {{ tr.nombre }}
                    </vs-td>
                    <vs-td>
                        <md-chip v-if="tr.sesiones.length > 0" class="mb-1 fontMedium mini-chip col-green">
                            <strong>
                                <span> {{tr.sesiones.length}}</span>
                            </strong>
                        </md-chip>
                        <md-chip v-else class="mb-1 fontMedium mini-chip col-yellow">
                            <strong>
                                <span>Sin Código de sesión</span>
                            </strong>
                        </md-chip>
                    </vs-td>
                    <vs-td>
                        {{ tr.ciclo_escolar ? tr.ciclo_escolar.nombre_ciclo : '' }}
                    </vs-td>
                    <vs-td>
                        {{ tr.programa ? tr.programa.nombre : '' }}
                    </vs-td>
                    <vs-td>
                        {{ tr.nivel_academico ? tr.nivel_academico.nivel : '' }}
                    </vs-td>
                    <vs-td>
                        <vs-row>
                            <vs-col vs-type="flex" style="display: -webkit-inline-box;"  w="12">
                                <vs-button icon size="mini" flat @click="activeCrn=!activeCrn; selectedRow = {...tr, timeStap:new Date()}; row = tr">
                                    <i class='fas fa-plus mini-icon' ></i>
                                </vs-button>
                                <vs-button primary icon flat size="mini" @click="activeEditar=!activeEditar; selectedRow = tr;">
                                    <i class="fas fa-edit mini-icon"></i>
                                </vs-button>
                                <vs-button v-if="tr.registros_academicos_vinculados == 0" danger icon flat size="mini" @click="activeEliminar=!activeEliminar; selectedRow = tr;">
                                    <i class="fas fa-trash mini-icon"></i>
                                </vs-button>
                            </vs-col>
                        </vs-row>     
                    </vs-td>
                        
                    <template #expand v-if="tr.sesiones.length > 0">
                        <div class="con-content">
                            <vs-alert warn v-if="tr.registros_academicos_vinculados != 0" class="mb-3">
                                <template #title>
                                    El grupo se encuentra bloqueado debido a que existen alumnos vinculados.
                                </template>
                            </vs-alert>
                            <vs-row>        
                                <vs-col lg="3" v-for="(sesion, j) in tr.sesiones || [] " :key="j" class="mb-2 d-flex">
                                    <div class="horarios"  style="width: 95%">
                                        <div class="mr-1">
                                            <p class="mb-0" v-if="sesion && sesion.docente_en_aula && sesion.docente_en_aula.nombres"><strong>{{sesion.docente_en_aula.nombres}} {{sesion.docente_en_aula.apellido_paterno}} {{sesion.docente_en_aula.apellido_materno}}</strong></p>
                                            <p class="mb-0" v-if="sesion && sesion.codigo_sesion && sesion.codigo_sesion.alias"><strong>{{sesion.codigo_sesion.alias}}</strong></p>
                                            <p class="mb-0" v-if="sesion && sesion.diaTitle">{{sesion.diaTitle}}</p>
                                            <p v-if="sesion.hora_inicio !== null && sesion.hora_fin !== null" class="mb-0">{{sesion.hora_inicio}} a {{sesion.hora_fin}}</p>
                                        </div>
                                        <div v-if="tr.registros_academicos_vinculados == 0" @click="removeCrn(tr.id, sesion, tr.sesiones)" style="cursor:pointer; width: 10%; display: flex; margin-left: auto ">
                                            <i class="far fa-times-circle m-auto"></i>
                                        </div>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </div>
                    </template>
                </vs-tr>
            </template>
            <template #notFound>
                No hay registros
            </template>
            <template #footer>
                <vs-pagination v-model="page" :length="pages" />
            </template>
        </vs-table>
    </div>
</template>

<script>
import ModalEditarCodigo from '../action-modals/editar'
import ModalCrearCodigo from '../action-modals/crear'
import ModalEliminarCodigo from '../action-modals/eliminar'
import ModalAgregarCrns from '../action-modals/agregar-crns'
import bloques from '../../../../api/requests/bloques.js'

export default {
    props:[
        'value',
        'listNiveles',
        'listCiclos',
        'institucion',
        'cicloEscolar',
        'nivelAcademico',
        'programa',
        'ejecutar'
    ],   
    data () {
        return {
            activeEditar: false,
            activeCrear: false,
            activeEliminar: false,
            activeCrn: false,
            selectedRow: null,
            tablaData: [],
            info:[],
            page: 1, 
            max: 5,
            pages: 0
        }
    },
    methods: {
        async removeCrn(id, deleteCrn, allCrns){
            try {
                const payload = {
                    ids: allCrns.map(e=>e.id).filter(e => e !== deleteCrn.id)
                }
                if (payload) {
                    await bloques.updateDetail(id, payload)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Registro guardado`
                    })
                    await this.tablaCodigos()
                }
            } catch (error) {
                if ( error && error.response && error.response.data && error.response.data.errors){
                    const data = error.response.data.errors
                    data.forEach(element => {
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element
                        })
                    });

                }else{
                    this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                    })
                }
            }
        },
        async tablaCodigos () {
            try {
                const loading = this.$vs.loading()
                let params = {
                    page: this.page || 1,
                    size: this.max || 20
                }
                if (this.cicloEscolar) {
                    params.ciclo_escolar_id = this.cicloEscolar 
                }
                if (this.nivelAcademico) {
                    params.nivel_academico_id = this.nivelAcademico 
                }
                if (this.programa) {
                    params.programa_id = this.programa 
                }
                const { data: response = null } = await bloques.listado (this.institucion, params) || {}
                const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.tablaData = dataTable
                loading.close()
            } catch (error) {
                loading.close()
                this.tablaData = []
                this.pages = 1
            }
        }
    },
    components: {
        ModalEditarCodigo,
        ModalCrearCodigo,
        ModalEliminarCodigo,
        ModalAgregarCrns
    },
    watch:{
        ejecutar () {
            this.tablaCodigos()
        },
        page () {
            this.tablaCodigos()
        },
        selectedRow (val) {
            if (val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style>
    div.bloques > div.vs-table > table{
        margin: 1.7% 0 !important;
        width: 100% !important;
    }

    div.bloques > header {
        background: none !important;
    }
    
    .horarios{
        background: rgb(214, 234, 248);
        color: #195BFF;
        padding: 1%;
        display: flex;
        border-radius: 7px;
    }

    .col-green{
        color: #55ce63 !important;
        background: rgb(232, 253, 235) !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236) !important;
        color: #febf3d !important;
    }
</style>